import React from 'react'
import Layout from 'components/Layout'
import { Link, graphql } from 'gatsby'
import styled from '@emotion/styled'
import { rhythm } from 'utils/typography'

const LatestPosts = styled.section`
  padding: ${rhythm(1 / 2)};

  h2 {
    color: #999999;
    margin-bottom: ${rhythm(3 / 2)};
  }

  a {
    text-decoration: none;
    color: black;
  }
`

const PostPreview = styled.div``
const PostTitle = styled.h3`
  margin-bottom: ${rhythm(1 / 4)};
`

const PublishedDate = styled.p``
const Excerpt = styled.p``

const Index = ({ data }) => {
  const latestPosts = data.allMdx.edges.map(({ node }) => node)

  return (
    <Layout>
      <LatestPosts>
        <h2>Latest Posts</h2>
        {latestPosts.map((post) => (
          <PostPreview key={post.id}>
            <Link to={`/blog${post.fields.slug}`}>
              <PostTitle>{post.frontmatter.title}</PostTitle>
            </Link>
            <PublishedDate>Published on {post.frontmatter.date}</PublishedDate>
            <Excerpt>{post.frontmatter.excerpt}</Excerpt>
          </PostPreview>
        ))}
      </LatestPosts>
    </Layout>
  )
}

export const query = graphql`
  query {
    allMdx(limit: 3, sort: { order: DESC, fields: frontmatter___date }) {
      edges {
        node {
          id
          fields {
            slug
          }
          frontmatter {
            title
            date(formatString: "MM/DD/YYYY")
            excerpt
          }
        }
      }
    }
  }
`

export default Index
